export default "__VITE_ASSET__9e836dc6__"